import { render } from "./taskManage.vue?vue&type=template&id=48ae486f&scoped=true&ts=true"
import script from "./taskManage.vue?vue&type=script&lang=ts"
export * from "./taskManage.vue?vue&type=script&lang=ts"

import "./taskManage.vue?vue&type=style&index=0&id=48ae486f&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ae486f"]])

export default __exports__